import React from 'react';
import { Encabezado } from '../styles';

const Header = () => {

    const handleClick = item => {
        document.getElementById(item).scrollIntoView();
    }

    return(
        <Encabezado>
            <nav>
                <img src="./img/logo.png" alt="Logo" />
                <ul>
                    <li><span onClick={() => handleClick('about')} style={{marginRight: '30px'}}>About</span></li>
                    <li><span onClick={() => handleClick('works')} style={{marginRight: '30px'}}>Works</span></li>
                    <li><span onClick={() => handleClick('contact')} >Contact</span></li>
                </ul>
            </nav>
        </Encabezado>
    );
}

export default Header;